import {
  getProductByHandle,
  getSubsProductByHandle,
  getProductByID,
  getSubsProductByID,
} from "./graphql/queryFactory";
import { cartCreateMutation } from "./graphql/mutationFactory";

/**
 * @class Engine, may be renamed to Fetcher
 * @description - This class is responsible for fetching data from the Shopify Storefront API / Lifeboost API
 * @imports - queryFactory, mutationFactory and their .gql -> ES6 exports (getProductByHandle, getSubsProductByHandle, getProductByID, getSubsProductByID, cartCreateMutation)
 * @usage :
 * import Engine from "@/scripts/requests/Engine";
 * const runEngine = new Engine();
 *
 *
 * TODO: - Add a method push into Tag Manager ATC Event + cart data + buyer identity
 * TODO: - Separate Sale Pages from Lifeboost APP Storefront API
 */

export default class Engine {
  constructor() {
    this.gqlEndpoint = "https://lifeboostcoffee.myshopify.com/api/2023-10/graphql.json";
    this.headers = {
      "X-Shopify-Storefront-Access-Token": "f6a2623322cec5baeeb67eadb9c40db1",
      "Content-Type": "application/json",
    };
    this.variants = [];
    this.pageData = null
  }


  /**
   * Grab data from Strapi api.lifeboostcoffee.com
   * @param {*} slug
   * @memberof Engine
   */
  async queryPage(slug) {
    try {
      const { data } = await $fetch(
        `/api/landing-pages/${slug}`
      );
      if (data[0])
        this.pageData = data[0];
        return data[0];
    } catch (err) {
      console.error("Page is not found!")
      try {
        const { data } = await $fetch(
          `/api/landing-pages/healthy-coffee-ot2e-19-cp`
        );
        if (data[0])
          this.pageData = data[0];
          return data[0];
      }
      catch (err) {
        throw new Error('Server error! Check API!');
      }
    }
  }





  /**
   * Say hello to Mr. Fetcher, universal fetcher for all your needs
   * @param {*} graphql
   * @return {*}
   * @memberof Engine
   */
  FETCHER = async (graphql) => {
    const requestOptions = {
      method: "POST",
      headers: this.headers,
      body: graphql,
    };

    return fetch(this.gqlEndpoint, requestOptions)
      .then((response) => response.json())
      .then((response) => {
        return response;
      })
      .catch((error) => console.log("error", error));
  };


  TRACKING = async (data, page, trackEvent) => {
    const cart = data?.data?.cartCreate?.cart

    if (!cart) {
      const userErrors = data?.data?.cartCreate?.userErrors || []
      const gqlErrors = data?.errors || []
      console.error("TRACKING: cart payload missing", { userErrors, gqlErrors })
      return
    }

    const products = cart.lines.edges;
    const inArray = products.map(function (product) {
      product = product.node
      let variant = product.merchandise
      return {
        "id": variant.sku,
        "variant_id": (variant.id).split('/').pop(),
        "product_id": (variant.product.id).split('/').pop(),
        "name": variant.product.title + ' - ' + variant.title,
        "brand": "Lifeboost",
        "category": "Low Acid Coffee",
        "variant": variant.title,
        "quantity": product.quantity,
        "price": variant.priceV2.amount,
        "image": variant.image.url
      }
    });

    trackEvent({
      "event": "dl_add_to_cart",
      "attributes": { "sale_page": page && page },
      "cartTotal": cart.cost.totalAmount.amount,
      "currencyCode": "USD",
      "ecommerce": {
        "add": {
          "products": inArray
        }
      }
    });

    axon("track", "add_to_cart",
      {
        "currency": "USD",
        "value": cart.cost.totalAmount.amount,
        "items": inArray.map(product => ({
          item_variant_id: product.variant_id,
          item_id: product.product_id,
          item_name: product.name,
          price: parseFloat(product.price),
          quantity: product.quantity,
          image_url: product.image,
          item_category_id: 1868,
          item_brand: "Lifeboost"
        }))
      }
    )


    //   const contentIds = inArray.map(product => product.id);
    //   fbq('track', 'AddToCart', {
    //     content_name: 'Lifeboost Coffee',
    //     content_category: 'Low Acid Coffee',
    //     content_ids: contentIds,
    //     content_type: 'product',
    //     value: data.data.cartCreate.cart.cost.totalAmount.amount,
    //     currency: 'USD'
    //   });
  }

  /**
* Track view_item event for all variants
* @param {Object} variant - Selected variant object
* @param {Object} pack - Selected pack object
* @return {void}
* @memberof Engine
*/
  VIEW_ITEMS_TRACKING(variant, pack) {
    if (!variant?.variant || !pack) return;

    // Get pack options for this variant
    const price = parseFloat(pack.Price.replace(/[^0-9.]/g, '')) || 0;
    const quantity = parseInt(pack.PackSize.replace(/[^0-9]/g, '')) || 1;

    const item = {
      // Required fields
      item_id: variant.variant.VariantID,
      item_name: `${variant.variant.VariantName} ${pack.PackSize}`,
      price: price,
      quantity: quantity,

      // Recommended fields
      image_url: variant.variant.FeaturedImage?.url,
      item_category_id: 1868,
      item_brand: "Lifeboost"
    };

    // Calculate total value
    const totalValue = item.price;

    // Construct the view_items event
    const viewItemsEvent = {
      currency: "USD",
      value: totalValue,
      items: [item]
    };

    // Track in AXON
    axon("track", "view_item", viewItemsEvent);
  }



  /**
   * @param { int } id - product id -> always enters
   * @param { int } qty - quantity -> always enters
   * @param { String } dCode - discount code -> NOT enters if no discount code assigned
   * @param { String } pack - pack -> NOT enters if no pack assigned
   * @param { String } plan - plan -> NOT enters if regular purchase
   * @memberof Engine
   */

  async checkout(id, qty, dCode, pack, plan, crossId, trackEvent) {
    let PageSale = window.location.pathname;

    const product = this.pageData.Products.find(product => product.Variants.find(variant => variant.variant.VariantID === id))
    const variant = product.Variants.find(variant => variant.variant.VariantID === id)
    const packSize = variant.Pack.find(pack => qty == pack.PackSize.replace('x', ''))

    let item = {
      merchandiseId: "gid://shopify/ProductVariant/" + id,
      quantity: Number(qty)
    }

    let adminOfferAttr = { attributes: [{ key: "Sale Page:", value: PageSale || 'no-data' }] }
    let frontOfferAttr = {}
    let discountAttr = {}

    pack && (frontOfferAttr = { attributes: [{ key: "Offer", value: pack || 'no-data' }] });
    pack && (adminOfferAttr.attributes.push({ key: "Offer", value: pack || 'no-data' }));

    plan &&
      (item = {
        ...item,
        sellingPlanId: "gid://shopify/SellingPlan/" + plan,
      });

    const upsellOffer = (crossId && !plan) ?
      { merchandiseId: "gid://shopify/ProductVariant/" + crossId, quantity: 1, "attributes": { "key": "Bundle", "value": "Signature Roast" } } : null
    dCode && (discountAttr = { discountCodes: [dCode] });

    const graphql = {
      query: cartCreateMutation.loc.source.body,
      variables: {
        input: {
          ...adminOfferAttr,
          lines: [{ ...item, ...frontOfferAttr }, upsellOffer && upsellOffer].filter(el => el !== null),
          ...discountAttr,
        },
        first: 10,
        linesFirst2: 10
      },
    }

    const finalGraphql = useCartTransformAPI(graphql, {
      cartTransformEnabled: this.pageData.cart_transformation_api,
      items: {
        [id]: {
          price: packSize.UnitPrice,
          storefrontTitle: packSize.StorefrontTitle,
          //packSize: packSize.PackSize,
          //packName: packSize.PackName
        }
      }
    });
    this.FETCHER(finalGraphql)
      .then((response) => {
        const cart = response?.data?.cartCreate?.cart

        if (!cart) {
          const userErrors = response?.data?.cartCreate?.userErrors || []
          const gqlErrors = response?.errors || []
          console.error("checkout: cartCreate failed", { userErrors, gqlErrors })
          return null
        }

        this.TRACKING(response, PageSale, trackEvent);
        return cart.checkoutUrl
      })
      .then((cart) => {
        if (cart) {
          window.location.href = cart;
        }
      });
  }




  async checkoutWithItems(items, trackEvent) {
    let PageSale = window.location.pathname;
    let adminOfferAttr = { attributes: [{ key: "Sale Page:", value: PageSale || 'no-data' }] };
    let lines = [];
    let discountCodes = [];

    for (const item of items) {
      const lineItem = {
        merchandiseId: "gid://shopify/ProductVariant/" + item.id,
        quantity: Number(item.quantity),
      };

      if (item.plan) {
        lineItem.sellingPlanId = "gid://shopify/SellingPlan/" + item.plan;
      }

      if (item.coupon) {
        discountCodes.push(item.coupon);
      }

      if (item.packName) {
        lineItem.attributes = [{ key: "Offer", value: item.packName || 'no-data' }];
        adminOfferAttr.attributes.push({ key: "Offer", value: item.packName || 'no-data' });
      }

      lines.push(lineItem);
    }
    const graphql = JSON.stringify({
      query: cartCreateMutation.loc.source.body,
      variables: {
        input: {
          ...adminOfferAttr,
          lines: lines,
          discountCodes: discountCodes,
        },
        first: 10,
        linesFirst2: 10,
      },
    });

    this.FETCHER(graphql)
      .then((response) => {
        const cart = response?.data?.cartCreate?.cart

        if (!cart) {
          const userErrors = response?.data?.cartCreate?.userErrors || []
          const gqlErrors = response?.errors || []
          console.error("checkoutWithItems: cartCreate failed", { userErrors, gqlErrors })
          return null
        }

        this.TRACKING(response, PageSale, trackEvent);
        return cart.checkoutUrl;
      })
      .then((cart) => {
        if (cart) {
          window.location.href = cart;
        }
      });
  }

  /**
   * @param {*} input
   * @return {*}
   * @memberof Engine
   */
  async fetchProduct(inputs) {
    await Promise.all(inputs.map(async (input) => {
      const graphql = JSON.stringify({
        query: getSubsProductByID.loc.source.body,
        variables: {
          productId: `gid://shopify/Product/${input}`,
          first: 10,
          variantsFirst2: 150,
        },
      });
      return this.FETCHER(graphql).then((response) => {
        this.variants = [...this.variants, ...response.data.product.variants.nodes]
      });
    }));
  }

  async fetchProductByHandle(input) {
    const graphql = JSON.stringify({
      query: getProductByHandle.loc.source.body,
      variables: {
        handle: input,
      },
    });

    return this.FETCHER(graphql).then((response) => {
      return response.data.product
    });
  }

  async fetchSubsProductByHandle(input) {
    const graphql = JSON.stringify({
      query: getSubsProductByHandle.loc.source.body,
      variables: input,
    });

    return this.FETCHER(graphql).then((response) => {
      return response.data.product
    });
  }

  async fetchProductById(input) {
    const graphql = JSON.stringify({
      query: getProductByID.loc.source.body,
      variables: { productId: input },
    });

    return this.FETCHER(graphql).then((response) => {
      return response.data.product
    });
  }

  getVariants() {
    return this.variants;
  }
  getVariant(id) {
    return this.variants.find(
      (variant) => variant.id == `gid://shopify/ProductVariant/${id}`
    );
  }
  getInStock(id) {
    return this.variants.find(
      (variant) => variant.id == `gid://shopify/ProductVariant/${id}`
    ).availableForSale;
  }
    handleVariantSelection(variant) {
    // Your existing variant selection logic
    const activePack = this.getActivePack(); // Get currently selected pack
    this.VIEW_ITEMS_TRACKING(variant, activePack);
  }

  handlePackSelection(pack) {
    // Your existing pack selection logic
    const activeVariant = this.getActiveVariant(); // Get currently selected variant
    this.VIEW_ITEMS_TRACKING(activeVariant, pack);
  }

  // Helper methods to get current selections
  getActiveVariant() {
    if (!this.salePageData?.Products?.[0]) return null;
    return this.salePageData.Products[0].Variants.find(v => v.Active);
  }

  getActivePack() {
    const activeVariant = this.getActiveVariant();
    if (!activeVariant) return null;
    return activeVariant.Pack.find(p => p.Active);
  }
}



